import script from "./InviaOrdine.vue?vue&type=script&setup=true&lang=js"
export * from "./InviaOrdine.vue?vue&type=script&setup=true&lang=js"

import "./InviaOrdine.vue?vue&type=style&index=0&id=2c98832c&lang=scss&scoped=true"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c98832c"]])

export default __exports__